export default {
  props: {
    value: { type: [String, Number], default: 0 },
    locale: String,
    precision: { type: Number, default: 2 },
    prefix: { type: String, default: '$' },
    suffix: { type: String, default: '' },
    separator: String,
    min: { type: Number, default: -Number.MAX_VALUE },
    max: { type: Number, default: Number.MAX_VALUE },
    maxLength: { type: Number, default: Number.MAX_VALUE },
    onlyPositive: Boolean,
  },

  data() {
    return {
      formattedValue: '',
      focused: false,
    };
  },

  computed: {
    groupSeparator() {
      if (this.separator) {
        return this.separator;
      }
      const n = 1000;
      return n.toLocaleString(this.localeString).charAt(1);
    },

    decimalSeparator() {
      const n = 1.1;
      return n.toLocaleString(this.localeString).charAt(1);
    },

    decimalSeparatorKeyCode() {
      return this.decimalSeparator.charCodeAt(0);
    },

    localeString() {
      // to test french input
      // return 'fr-CA';
      return this.locale ? `${this.locale}-CA` : undefined;
    },
  },

  watch: {
    '$i18n.locale': function i18nLocale() {
      this.formattedValue = this.format(this.value);
    },

    value(newValue) {
      if (!this.focused) {
        this.formattedValue = this.format(newValue);
      }
    },
  },

  mounted() {
    this.formattedValue = this.format(this.value);
  },

  methods: {
    keypress(e) {
      const keyCode = e.keyCode ? e.keyCode : e.which;
      if (this.precision === 0 && keyCode === this.decimalSeparatorKeyCode) {
        e.preventDefault();
        return;
      }

      if ((keyCode < 48 || keyCode > 57) && keyCode !== this.decimalSeparatorKeyCode) {
        e.preventDefault();
        return;
      }

      if (this.formattedValue.toString().length >= this.maxLength) {
        e.preventDefault();
        return;
      }

      if (!this.onlyPositive && keyCode === 45) {
        const v = -this.parse(this.formattedValue);
        this.formattedValue = v;
        this.$emit('input', v);
      }
    },

    fixString(n) {
      const gs = this.groupSeparator === ' ' ? '\\s' : this.groupSeparator;
      return n
        .replace(new RegExp(`[${gs}]`, 'g'), '')
        .replace(new RegExp(`[${this.decimalSeparator}]`, 'g'), '.');
    },

    formatLocale(n, useGrouping = true, minPrecision) {
      const p = this.precision;
      return Number(n).toLocaleString(this.localeString, {
        maximumFractionDigits: p,
        minimumFractionDigits: _.isNumber(minPrecision) ? minPrecision : p,
        useGrouping,
      });
    },

    parseFloat(n) {
      n = parseFloat(this.fixString(n));
      if (_.isNaN(n)) {
        n = 0;
      }
      return n;
    },

    parse(value, asString = false) {
      let n = value;

      if (_.isNumber(n)) {
        n = this.formatLocale(n);
      }
      if (_.isEmpty(n)) {
        n = '0';
      }

      n = this.fixString(n
        .replace(new RegExp(`^${this.prefix}`), '')
        .replace(new RegExp(`${this.suffix}$`), ''));

      n = this.parseFloat(this.formatLocale(n, false));

      return asString ? this.formatLocale(n, false, 0) : n;
    },

    format(number) {
      let n = number;

      if (_.isString(n)) {
        n = this.parseFloat(n);
      }
      if (_.isNaN(n)) {
        n = 0;
      }

      n = Math.max(Math.min(n, this.max), this.min);

      return `${this.prefix}${this.formatLocale(n)}${this.suffix}`;
    },

    input(v) {
      if (_.isEmpty(v)) {
        v = 0;
      }
      this.formattedValue = this.parse(v, true);
    },

    focus() {
      this.focused = true;
      this.formattedValue = this.parse(this.value, true);
      this.$nextTick(() => {
        this.$emit('input', this.parse(this.value));
      });
    },

    blur() {
      this.focused = false;
      this.formattedValue = this.format(this.value);
      this.$emit('input', this.parse(this.value));
    },
  }
};
